'use client'

import Image from 'next/image'
import { type ReactNode } from 'react'
import { ABHA_HERO_BACKGROUND, TRUST_BADGE_LOGO } from '@components/NewProduct/constants'
import { ARTICLE_HEADER_ALIGNED_CONTAINER_CLASS } from '@components/Articles/articleLayout'
import PropertyControlledComponent from '@components/PropertyControlledComponent/PropertyControlledComponent'
import { AbhaHeroWidget } from '../AbhaHeroWidget'
import './abhaProductHero.css'

export type AbhaProductHeroProps = {
  widgetData?: any
  header?: ReactNode
  isMobile?: boolean
  className?: string
  segmentEventCommonProperties?: Record<string, any>
  searchParams?: Record<string, string>
}

export const AbhaProductHero = ({
  widgetData,
  header,
  className,
  segmentEventCommonProperties = {},
  searchParams = {},
}: AbhaProductHeroProps) => (
  <section className={`@container ${className ?? ''}`} style={{ background: ABHA_HERO_BACKGROUND }}>
    {header}

    <div
      className={`${ARTICLE_HEADER_ALIGNED_CONTAINER_CLASS} pb-40 pt-[88px] md:pb-48 md:pt-[120px] lg:pb-56 lg:pt-[128px]`}>
      <div className="mx-auto flex max-w-[1280px] flex-col items-center gap-20 lg:flex-row lg:items-center lg:justify-between lg:gap-80">
        {/* Copy column — flex centering handles mobile alignment */}
        <div className="flex w-full max-w-[840px] flex-col items-center gap-12 lg:items-start lg:gap-20">
          <div className="abha-product-hero__copy-stack">
            <PropertyControlledComponent controllerProperty={!!widgetData?.badgeLabel} fallback={null}>
              <p className="abha-product-hero__badge">{widgetData?.badgeLabel}</p>
            </PropertyControlledComponent>

            <PropertyControlledComponent controllerProperty={!!widgetData?.heading} fallback={null}>
              <h1 className="abha-product-hero__heading">{widgetData?.heading}</h1>
            </PropertyControlledComponent>

            <PropertyControlledComponent controllerProperty={!!widgetData?.subHeading} fallback={null}>
              <p className="abha-product-hero__subheading">{widgetData?.subHeading}</p>
            </PropertyControlledComponent>
          </div>

          {/* Trust badge with NHA Logo Image */}
          <div className="mt-4 flex flex-col items-center gap-8 lg:mt-0 lg:items-start">
            <Image
              src={TRUST_BADGE_LOGO.imageSrc}
              alt={TRUST_BADGE_LOGO.alt}
              width={TRUST_BADGE_LOGO.width}
              height={TRUST_BADGE_LOGO.height}
              className="h-52 w-auto object-contain lg:h-72"
            />
            <PropertyControlledComponent controllerProperty={!!widgetData?.disclaimer} fallback={null}>
              <p className="abha-product-hero__disclaimer">{widgetData?.disclaimer}</p>
            </PropertyControlledComponent>
          </div>
        </div>

        {/* Widget card — image + form in one white card */}
        <AbhaHeroWidget
          widgetOptions={widgetData?.widgetOptions}
          modalOptions={widgetData?.modalOptions}
          segmentEventCommonProperties={segmentEventCommonProperties}
          searchParams={searchParams}
        />
      </div>
    </div>
  </section>
)
